(function ($) {
    var countdownElement = $('[data-action="countdown"]'),
        init = function () {
            var seconds = countdownElement.data("start-from");
            var countdown = setInterval(function () {
                seconds--;
                countdownElement.html(seconds);
                if (seconds <= 0) {
                    clearInterval(countdown);
                }
            }, 1000);
        };

    return init();
})(jQuery);